"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelCode = exports.Id = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Device.Class.Common';
exports.Id = effect_1.Schema.String.pipe(effect_1.Schema.minLength(22), effect_1.Schema.maxLength(27)).annotations({
    identifier: `${exports.NAMESPACE}.Id`,
    description: 'A unique identifier (ID) corresponding to the Serial Number of the device',
    examples: ['CULBFCDEV-ABCD1234EFGH56'],
});
exports.ModelCode = effect_1.Schema.Literal('bbfc', 'fbfc', 'gbfc', 'htb', 'ro1', 'tlro').annotations({
    identifier: `${exports.NAMESPACE}.ModelCode`,
});
//# sourceMappingURL=common.js.map